var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 120,
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.922 53.1075L114.3 51.5116V54.4043L108.823 55.0028L111.983 74.2551H100.922V53.1075Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2226 93.7392L100.922 96.3285",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8 44.5865L67.3384 22.3173C68.377 12.5082 86.2577 -0.987614 107.954 19.0865C110.03 21.0082 111.415 30.8542 111.415 40.4324M64.8 44.5865L111.415 40.4324M64.8 44.5865C72.3 53.2014 85.8923 71.2392 80.2615 74.4693C73.2231 78.5076 71.3769 78.7389 70.9154 81.8538C70.5461 84.3468 70.223 88.1232 70.1076 89.7H72.877L75.7615 86.4699H86.7231V93.6231L85.5692 95.7003V101.585L86.7231 102.97L82.5692 111.739H88.4539C96.9921 105.277 105.877 101.585 105.877 95.7003C105.877 90.9006 105.877 81.6234 105.877 77.5851H95.8383L96.9921 56.9311C97.0308 54.3542 97.3386 49.6619 102.992 48.1618C107.824 46.88 112.031 45.9695 113.608 45.3926L111.415 40.4324",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.955 22.5465C103.493 20.8542 91.287 14.6927 76.1714 22.077C70.3572 24.9173 69.0441 38.6846 68.8133 42.1461M108.762 44.7008C101.57 45.4315 86.3546 47.0085 83.0315 47.47C78.8776 48.0469 72.8777 48.9701 76.6853 55.0855C80.493 61.2006 83.6084 68.0082 88.2238 68.8164C91.9161 69.4626 93.8394 69.7011 94.3389 69.7389",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3384 102.856L100.922 100.343",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5696 95.7012H75.1849V101.585H85.5696",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2227 95.7012C75.4535 92.7393 74.5843 87.3699 77.2611 89.5857C79.9381 91.8015 83.4535 94.5861 84.8766 95.7012",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3053 101.569C75.5361 104.53 74.6669 109.9 77.3437 107.684C80.0207 105.469 83.5361 102.684 84.9592 101.569",
    stroke: "black",
    strokeOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutboard);
export default __webpack_public_path__ + "static/media/outboard.2fd3015eac31b4aef968c3af4c38e32a.svg";
export { ForwardRef as ReactComponent };